import React, { useState, useEffect } from 'react'
import DataTable from '../Shared/DataTable/DataTable.js'
import * as FieldTypes from '../Shared/FieldTypes/FieldTypes.js'
import ItemDetailsPane from './ItemDetailsPane.js'
import AddItemPopup from './AddItemPopup.js'
import LoadingSpinnerImage from '../Shared/LoadingSpinnerImage.js'

const ComplianceStandards = () => {

    const [isLoadingStructure, setIsLoadingStructure] = useState(true);
    const [errorLoadingStructure, setErrorLoadingStructure] = useState(false);
    const [dataTableStructure, setDataTableStructure] = useState({});

    let config = {};

    config.dataUrl = "/umbraco/api/Compliance/Standards";
    config.getSingleItemUrl = "/umbraco/api/Compliance/Standard";
    config.pageTitle = "Standards";
    config.singleItemTitle = "Standard";
    config.entityType = "compliance-standards";
    config.entityTypeId = 4;
    config.pageIcon = "fas fa-file-contract";
    config.breadcrumbs = [{ "Name": "Compliance Manager", "Link": "/your-medboard/compliance-portfolio/" }, { "Name": "Standards", "Link": "/your-medboard/compliance-portfolio/standards/" }]
    config.dataStructure = [];
    config.showComplianceStatusFilter = false;
    config.exportUrl = "/umbraco/api/Compliance/StandardsExport/?standardsIds=";
    config.showTotalAndFilteredCounts = true;
    config.ComplianceType = "Standards";
    config.enableTags = true;
    config.showLegalManufacturerFilter = true;
    config.currentLegalManufacturerFilter = window.legalManufacturerId;
    config.currentLegalManufacturerNameFilter = window.legalManufacturerName;
    config.enableCustomFields = true;
    config.showRIMSFilter = true;
    config.enableMultiItemAIChatPane = true;
    config.showExportButton = true;
    config.preLoadItemUrlParamName = "viewItemId";
    config.excelExportFileName = "MedBoardComplianceExport";
    config.preLoadItemId = window.preloadStandardId;
    config.reachedAllowance = window.reachedAllowanceStandards ? window.reachedAllowanceStandards : false;
    config.showTaskCount = true;
    config.showCMArchiveFilter = true;

    useEffect(() => {

        loadStructure();

    }, []);


    const loadStructure = () => {

        setIsLoadingStructure(true);
        setErrorLoadingStructure(false);

        let tableHeaderUrl = "/umbraco/api/CustomFields/Headers/?entityType=" + config.entityTypeId;
        //let tableHeaderUrl = "/umbraco/api/CustomFields/FieldsConfiguration/?entityType=" + config.entityTypeId;

        let requestOptions = {
            method: 'GET',
        };

        fetch(tableHeaderUrl, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    setHasMoreData(false);
                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((result) => {

                result.map(column => {
                    config.dataStructure.push({
                        customFieldId: column.CustomFieldId,
                        customFieldType: column.CustomFieldType,
                        name: column.Name,
                        field: column.Field,
                        width: column.Width,
                        sortable: column.Sortable,
                        isSelectItemCheckbox: column.IsSelectItemCheckbox,
                        renderWith: FieldTypes[column.RenderWith] ?? FieldTypes.FieldType_Text,
                        isMultiField: column.IsMultiField,
                        hasFilter: column.HasFilter 
                        //hasFilter: true // FOR TESTING
                    });
                });

                setDataTableStructure(config);
                setIsLoadingStructure(false);
            })
            .catch((error) => {
                setErrorLoadingStructure(true);
            })
            .finally(() => {
            });
    }





    //dataTableStructure.dataStructure.push({ name: "", field: "Id", width: "25px", sortable: false, isSelectItemCheckbox: true });
    //dataTableStructure.dataStructure.push({ name: "Reference", field: "Name", width: "15%", sortable: true, renderWith: FieldTypes.FieldType_Text });
    //dataTableStructure.dataStructure.push({ name: "Description", field: "Description", width: "30%", sortable: true, renderWith: FieldTypes.FieldType_Text });
    //dataTableStructure.dataStructure.push({ name: "Stage", field: "Stage", width: "10%", sortable: true, renderWith: FieldTypes.FieldType_Compliance_Stage });
    //dataTableStructure.dataStructure.push({ name: "File", field: "MediaPath", width: "5%", sortable: true, renderWith: FieldTypes.FieldType_MediaPath, isMultiField: ["MediaPath", "MedboardResourceId"] });
    //dataTableStructure.dataStructure.push({ name: "Year", field: "Year", width: "5%", sortable: true, renderWith: FieldTypes.FieldType_Text });
    //dataTableStructure.dataStructure.push({ name: "Compliance Status", field: "Status", width: "20%", sortable: false, renderWith: FieldTypes.FieldType_Compliance_Status });
    //dataTableStructure.dataStructure.push({ name: "Legal Manufacturer", field: "LegalManufacturerId", width: "15%", sortable: false, renderWith: FieldTypes.FieldType_Compliance_LegalManufacturer });
    //dataTableStructure.dataStructure.push({ name: "Open Tasks", field: "TaskCount", width: "100px", sortable: true, renderWith: FieldTypes.FieldType_Open_Tasks });

    //dataTableStructure.dataUrlParameters = { search: null, page: 1, orderByField: "Name", orderByType: "ASCENDING", }


    return (<>

        {errorLoadingStructure ? <>
            <Error message={"Failed to load table configuration"} />
        </> : <>
                {isLoadingStructure ? <>
                    <LoadingSpinnerImage />
                </> : <>
                        <DataTable dataTableStructure={dataTableStructure} ItemDetailsPane={ItemDetailsPane} AddItemPopup={AddItemPopup} ReloadStructureFunction={loadStructure} />
                </>}

        </>}


    </>);



};






export default ComplianceStandards;